const AppConstants =
    {
        COLOR: {
            REPORT_FILL: '#84AEFF',
            REPORT_FILL_OUTLINE: '#84AEFF',
        },
    };

export default AppConstants;
